<template>
    <div>
        <div class="w3-col w3-margin-bottom flow-padding-bottom w3-center">
            <h5 v-if="room && room.enabled !== true" class="flow-blue-color zero-bottom zero-top">
                <p class="zero">
                    <i class="fa fa-exclamation-triangle w3-text-deep-orange flow-margin-right"></i>
                    <span class="w3-text-red font-weight-bold w3-margin-right">
                        {{ $t('warnDisabledSharedRoom') }}
                    </span>
                    <span class="flow-btn w3-btn w3-round-medium flow-blue-color" @click="enableRoom">
                        <i class="fa fa-check-circle flow-green-active-color"></i>
                        {{ $t('enable') }}
                    </span>
                </p>
            </h5>
        </div>

        <div v-bind:class="openPatientCard ? 'w3-container content-sidebars sidebars-50-50' : 'flow-main-content w3-margin-bottom'">
            <div v-show="!openPatientCard" class="flow-card blue-top w3-col" style="min-height: 300px">

                <ongoing-consultation-card
                        :isCallerActive="isGroupActive"
                        :ongoing="ongoing"
                        :roomActions="roomActions"
                        :consultationGroup="group.group">
                </ongoing-consultation-card>

                <!--Call doctor-->

                <span v-if="ongoing && ongoing.appointment.physician">
                    <h5 class="flow-blue-color w3-center" v-if="(!latestCall || latestCall.appointmentId !== ongoing.appointment.id) && !doctorCalled">
                        <button class="flow-btn w3-btn w3-border w3-padding w3-round-medium" @click="callDoctor">
                            {{$t("callPhysicianToExam", {'physician' : ongoing.appointment.physician.name})}}
                        </button>
                    </h5>

                    <h5 class="flow-blue-color w3-center" v-else>
                        <button class="flow-badge w3-padding w3-round-medium">
                            {{$t("physicianNotified", {'physician' : ongoing.appointment.physician.name})}}
                        </button>
                    </h5>
                </span>

            </div>

            <div v-bind:class="openPatientCard ? 'zero w3-col content-sidebar-left' : 'w3-col w3-margin-top w3-margin-bottom'">
                <patients-for-caller :room="room" :patients="patients" :onSelectCallback="openPatient" :isShared="true" :openPatientCard="openPatientCard"  :physician="ongoing ? ongoing.appointment.physician : undefined"></patients-for-caller>
            </div>

            <div v-if="openPatientCard"
                 class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
                <patient-side-card class="flow-padding-top"
                                   :selectedPatient="selectedPatient"
                                   :selectedPatientStatus="selectedPatient.status"
                                   :selectedPatientDevice="selectedPatient.device"
                                   :onClose="() => {openPatientCard = false;}"></patient-side-card>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import ContentHeader from "../common/ContentHeader";
    import PatientsForCaller from "./PatientsForCaller";
    import PatientSideCard from "../patient/PatientSideCard";
    import OngoingConsultationCard from "./OngoingConsultationCard";
    import { EventBus } from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationInSharedRoom",
        components: {OngoingConsultationCard, PatientSideCard, PatientsForCaller, ContentHeader},
        props: ["roomId"],
        data() {
            return {
                patients: [],
                ongoing: undefined,
                openPatientCard: false,
                selectedPatient: undefined,
                wardId: Vue.prototype.$currentWard.id,
                roomActions: [],
                group: {},
                room: undefined,
                doctorCalled: false,
                latestCall: undefined,
                refreshIntervalId: undefined,
                patientRefreshIntervalId: undefined
            }
        },
        computed: {
            isGroupActive() {
                return this.group && this.group.active === true;
            },
        },
        mounted() {
            this.getRoom();

            this.refreshIntervalId = setInterval(this.refresh, 8000);
            this.patientRefreshIntervalId = setInterval(this.refreshPatients, 5000);
            EventBus.$on("patientUpdated", this.updateStatus);
            EventBus.$on("onClickCallerStatusChange", this.toggleConsultationGroupStatus);
            EventBus.$on("onClickRoomAction", this.runRoomAction);
            EventBus.$on("manuallyCalledPatient", this.getOngoingConsultationInRoom);

            this.getLatestCallMade();
        },
        beforeDestroy() {
            clearInterval(this.refreshIntervalId);
            clearInterval(this.patientRefreshIntervalId);
            EventBus.$off("patientUpdated", this.updateStatus);
            EventBus.$off("onClickCallerStatusChange", this.toggleConsultationGroupStatus);
            EventBus.$off("onClickRoomAction", this.runRoomAction);
            EventBus.$off("manuallyCalledPatient", this.getOngoingConsultationInRoom);
        },
        methods: {
            refresh() {
                this.getLatestCallMade();
                this.getOngoingConsultationInRoom();
                this.getConsultationGroup();
            },
            refreshPatients() {
                this.getPatientsForRoom();
            },
            getLatestCallMade() {
                var app = this;
                app.doctorCalled = false;
                frc.getLatestCallMadeByExamRoom(this.wardId, this.roomId).then(function (res) {
                    app.latestCall = res.data;
                }).catch(function (ex) {
                    console.log(ex);
                })
            },
            getPatientsForRoom() {
                const app = this;
                frc.getPatientsForRoom(this.wardId, this.roomId).then(function(res) {
                    app.patients = res.data;
                });
            },
            getOngoingConsultationInRoom() {
                const app = this;

                frc.getOngoingConsultationInRoom(this.wardId, this.room.id).then(function (res) {
                    app.ongoing = res.data;
                });
            },
            runRoomAction(roomAction) {
                const app = this;

                if ("true" === Vue.getRoomActionUISetting(roomAction, "pauseCaller", "false")) {
                    frc.pauseConsultationGroup(this.wardId, this.group.group.id).then(function(res) {
                       app._runRoomAction(roomAction);
                       app.getConsultationGroup();
                    }).catch(function(ex) {
                        Vue.notifyError({
                            title: app.$t("failedToPause")
                        });
                        app._runRoomAction(roomAction);
                    });
                } else {
                    this._runRoomAction(roomAction);
                }
            },
            _runRoomAction(roomAction) {
                const app = this;

                frc.runRoomAction(this.wardId, this.room.id, this.ongoing.appointment.id, roomAction.id).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t("success"),
                        message: roomAction.displayName
                    });
                    app.getOngoingConsultationInRoom();
                });
            },
            openPatient(patient) {
                this.selectedPatient = patient;
                this.openPatientCard = true;
            },
            getRoomActions() {
                const app = this;

                frc.getRoomActions(this.wardId, this.room.id).then(function (res) {
                    app.roomActions = res.data;
                });
            },
            getConsultationGroup() {
                const app = this;

                frc.getConsultationGroup(this.room.group.id).then(function(res) {
                    app.group = res.data;
                });
            },
            toggleConsultationGroupStatus() {
                var promise;
                if (this.group.active === true) {
                    promise = frc.pauseConsultationGroup(this.wardId, this.group.group.id);
                } else {
                    promise = frc.activateConsultationGroup(this.wardId, this.group.group.id);
                }

                const app = this;

                promise.then(function(res) {
                    app.getConsultationGroup();
                    app.getOngoingConsultationInRoom();
                });
            },
            enableRoom() {
                var app = this;

                frc.enableSharedRoomInWard(this.wardId, this.room.id).then(function (res) {
                    Vue.notifySuccess({title: app.$t("successfullyEnabledRoom")});
                    app.getRoom();
                    app.refresh();
                });
            },
            getRoom() {
                var app = this;

                frc.getConsultationRoomInWard(app.wardId, app.roomId).then(function(res) {
                    app.room = res.data;
                    if (!app.room || !app.room.id) {
                        Vue.notifyError({
                            title: app.$t("FAILED_TO_FETCH") + ' ' + app.$t("consultationRoom")
                        });

                        return;
                    }

                    app.getRoomActions();
                    app.getConsultationGroup();
                    app.getOngoingConsultationInRoom();
                    app.getPatientsForRoom();
                });
            },
            updateStatus(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Patient not found.");
                        return;
                    }
                    app.selectedPatient.status = res.data.status;
                    app.getOngoingConsultationInRoom();
                });
            },
            callDoctor() {
                var app = this;
                frc.callDoctorToExaminationRoom(this.wardId, this.ongoing.appointment.physician.id, {
                    appointmentId: this.ongoing.appointment.id,
                    roomId: this.room.id
                }).then(function (res) {
                    app.doctorCalled = true;
                }).catch(function (ex) {
                    console.log(ex);
                })
            }
        }
    }
</script>

<style scoped>

</style>